import React, { useState } from "react";
import Slider from "react-slick";
import "./BannerSlider.scss";

const BannerSlider = ({ banners = [], handleBanner }) => {
  const [imageIndex, setImageIndex] = useState(0);
  const filePath = process.env.REACT_APP_FILE_PATH;

  // Slider configuration
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: false,
    centerMode: true,
    centerPadding: "44px",
    beforeChange: (current, next) => setImageIndex(next),
    className: "bannerSlider"
  };

  const handleBannerClick = (banner) => {
    if (typeof handleBanner === "function") {
      handleBanner(banner);
    }
  };

  // If there are no banners, show a placeholder or return null
  if (banners.length === 0) {
    return <div className="bannerSlider-empty">Нет баннеров</div>;
  }

  return (
    <Slider {...settings}>
      {banners.map((banner, index) => (
        <div
          key={banner.id || index} // Use a unique id if available, fallback to index
          className={`slide ${index === imageIndex ? "activeSlide" : ""}`}
          onClick={() => handleBannerClick(banner)}
        >
          <div className="slideImage-div">
            <img
              src={`${filePath}/Banners/${banner.fileName}`}
              alt={banner.title || "Banner"}
              className="slideImage"
            />
            <div className="grad"></div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default BannerSlider;
